<template>
  <div class="py-4 container-fluid">
    <div v-if="!isLoading" class="row">
      <div class="col-12">
        <navbaroptions
          isBlur="blur border-radius-lg py-2 start-0 end-0 mb-3 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
          toRoute="/agreement-card/0"
        />
      </div>
      <div class="col-12">
        <argon-alert v-if="showAlert" color="danger" :dismissible="true" @close-alert="closeAlert">
          <strong>Convenio!</strong> Eliminado correctamente!
        </argon-alert>
      </div>
      <div
        class="col-lg-6 col-md-6 col-12 mb-4"
        v-for="agreement in agreements"
        :key="agreement.id"
      >
        <!-- <router-link :to="`/Bypass`"> -->
        <agreements-table :agreement="agreement" />
        <!-- </router-link> -->
      </div>
    </div>
  </div>
</template>

<script>
import AgreementsTable from "./components/AgreementsTable.vue";
import Navbaroptions from "@/examples/PageLayout/Navbaroptions.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

export default {
  name: "agreement",
  components: { AgreementsTable, Navbaroptions, ArgonAlert },
  data() {
    return {
      agreements: undefined,
      isLoading: true,
      showAlert: false,
    };
  },
  created() {
    this.plain
      .get(`/agreements`)
      .then((response) => {
        // console.log('AGREEMENTS TOTALES');
        // console.log(response.data);
        if (response.data.length !== 0) this.agreements = response.data;
        else this.agreements = [];
        this.isLoading = false;
      })
      .catch((err) => {
        this.agreements = [];
        this.isLoading = false;
        console.log(err);
      });
  },
  methods: {
    deleteItemAgreement(agreementID) {
      this.showAlert = true
      this.agreements = this.agreements.filter(({ id }) => id !== agreementID);
      // console.log("AGREEMENTS AGREEMENTS AGREEMENT");
      // console.log(this.agreements);
      window.scrollTo(0, 0);
    },
    closeAlert(){
      this.showAlert = false;
    }
  },
};
</script>
